import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Form as BForm,
  Row,
  Col,
  Badge,
  Spinner,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import CreatableSelect from "react-select/creatable";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import useStaffForm from "../hooks/useStaffForm";
import { AdminsRoutes } from "../../../../routes";
import { customLabel, permissionLabel } from "../../../../utils/helpers";
import "./style.scss";
import Toggle from "../../../../components/Toggle/Toggle";
import { resetStaffForm , setSelectedGroup} from "../../../../store/redux-slices/staffSlice";
import { UserPermissions } from "./constant";



const StaffForm = ({
  values,
  handleChange,
  handleSubmit,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  setFieldError,
  errors,
  touched,
  isValid,
  validateField,
  dirty,
  isEdit = false,
  staffDetails,
  originalPhone = null, // Add originalPhone prop
}) => {
  const { submitting } = useSelector((state) => state.staff || {});
  const [phoneError, setPhoneError] = useState("");
  const dispatch = useDispatch();
  const {
    groupChangeHandler,
    handleCreateGroup,
    roleChangeHandler,
    permissionHandler,
    togglePassword,
    adminRoles,
    adminsList,
    adminDetails,
    groupOptions,
    selectedGroup,
    passwordType,
    managrialPermissions,
    navigate,
    // Add username checking returns
    usernameStatus,
    handleUsernameChange,
  } = useStaffForm({
    group: values?.group,
    role: values?.role,
    adminId: values?.adminId,
    isEdit,
    values,
    setFieldValue,
    setFieldError,
    touched,
    setFieldTouched,
    validateField,
    staffDetails
  });
console.log({values}, values.phone  , "valuesvaluesvalues")
  useEffect(() => {
    if (!isEdit) {
      dispatch(resetStaffForm());
    }
  }, [isEdit]);

  // Add this useEffect to monitor form state
  useEffect(() => {
    console.log('Form state changed:');
    console.log('- isValid:', isValid);
    console.log('- errors:', errors);
    console.log('- touched:', touched);
    console.log('- values:', values);
  }, [isValid, errors, touched, values]);

  // Helper function to check if phone number has changed
  const hasPhoneChanged = (currentPhoneCode, currentPhone) => {
    if (!isEdit || !originalPhone) return false;

    const currentFullPhone = `${currentPhoneCode} ${currentPhone}`;
    return currentFullPhone !== originalPhone;
  };
  useEffect(() => {
    if (adminDetails?.userPermission?.permission) {
      // considering the initial values if it else 
      const normalizedPermission = isEdit ? { ...values.permission } : {};


      Object.keys(adminDetails.userPermission.permission).forEach((key) => {
        const validPermissions = UserPermissions[key] || [];

        // Get existing permissions or fallback to empty array
        const existingPermissions = normalizedPermission[key] || [];

        // Filter only valid permissions
        normalizedPermission[key] = existingPermissions.filter((perm) =>
          validPermissions.includes(perm)
        );

      });
      setFieldValue("permission", normalizedPermission);
    }
  }, [adminDetails?.userPermission?.permission ,  values.adminId]);

  // Real-time validation handler
  const handleRealTimeChange = async (e) => {
    const { name, value } = e.target;

    // Update the field value first
    handleChange(e);

    // For edit mode, mark as touched immediately to show validation
    // For create mode, mark as touched after user starts typing
    if (isEdit || value.length > 0) {
      setFieldTouched(name, true);
    }

    // Validate the field after a short delay if validateField is available
    if (typeof validateField === "function") {
      setTimeout(() => {
        validateField(name);
      }, 100);
    }
  };

  useEffect(() => {
    return () => {
    // Clean up by resetting the Group when component unmounts
    dispatch(setSelectedGroup(null));
    }
  } , [])

  const handleUsernameFieldChange = (e) => {
    const { value } = e.target;
    
    console.log('Input field changed to:', value);
    
    // Update formik value first
    handleChange(e);
    
    // Mark as touched for validation
    if (isEdit || value.length > 0) {
      setFieldTouched('adminUsername', true);
    }
    
    // Clear any existing Formik errors first
    if (setFieldError) {
      setFieldError('adminUsername', '');
    }
    
    // // If input is empty, clear username status immediately
    // if (!value || value.trim() === '') {
    //   clearUsernameStatus();
    //   return;
    // }
    
    // This will now be properly debounced
    handleUsernameChange(e, isEdit ? staffDetails?.adminUserId : null);
    
    // Validate field after delay (for other validations)
    if (typeof validateField === "function") {
      setTimeout(() => {
        validateField('adminUsername');
      }, 100);
    }
  };

  // Real-time blur handler
  const handleRealTimeBlur = (e) => {
    const { name } = e.target;
    setFieldTouched(name, true);
    handleBlur(e);

    // Only call validateField if it's a function
    if (typeof validateField === "function") {
      validateField(name);
    }
  };

  const validatePhone = (phone, country) => {
    if (!phone || phone.length < 7) {
      return "Phone number is required and must be at least 7 digits";
    }

    // Check if phone starts with 0 after country code
    const phoneWithoutCountryCode = phone.substring(country.dialCode.length);
    if (phoneWithoutCountryCode.charAt(0) === "0") {
      return "Phone number should not start with 0 after country code";
    }

    // Updated length validation - max 10 digits for phone number part
    if (
      phoneWithoutCountryCode.length < 6 ||
      phoneWithoutCountryCode.length > 10
    ) {
      return "Phone number must be between 6 and 10 digits";
    }

    return "";
  };

  const getSupervisorRole = (role) => {
    let supervisorRole = "";

    if (role === "Manager") {
      supervisorRole = "Admin";
    } else {
      supervisorRole = "Manager";
    }

    return supervisorRole;
  };

  const supervisorRole = getSupervisorRole(values.role);
  // Helper function to determine if field should show validation
  const shouldShowValidation = (fieldName) => {
    // In edit mode, show validation if field is touched OR has errors
    if (isEdit) {
      return touched[fieldName] || !!errors[fieldName];
    }

    // In create mode, show validation if touched OR has content
    return (
      touched[fieldName] || (values[fieldName] && values[fieldName].length > 0)
    );
  };

  // Check if all required fields have values
  const hasRequiredFieldValues = () => {
    // Check basic required fields
    const requiredFields = [
      "email",
      "firstName",
      "lastName",
      "adminUsername",
      "phone",
      "group",
      "role",
    ];

    // For create mode, password is required
    // For edit mode, password is optional (empty means keep current password)
    if (!isEdit) {
      if (!values.password || values.password.trim() === "") {
        return false;
      }
    }

    // Check if any required field is empty
    for (const field of requiredFields) {
      const value = values[field];
      if (!value || (typeof value === "string" && value.trim() === "")) {
        return false;
      }
    }

    // Check supervisor selection for Staff/Manager roles
    if (["Staff", "Manager"].includes(values.role) && !values.adminId) {
      return false;
    }

    return true;
  };

  // Check if permissions are properly selected
  const arePermissionsValid = () => {
    // If role doesn't require permissions, return true
    if (!["Admin"].includes(values?.role) && !values.adminId) {
      return true;
    }

    // If adminDetails or permissions are not loaded yet, return false
    if (!adminDetails?.userPermission?.permission) {
      return false;
    }

    // If permissions object doesn't exist, return false
    if (!values.permission) {
      return false;
    }

    // Check if at least one permission is selected across all categories
    const allPermissionCategories = Object.keys(
      adminDetails.userPermission.permission
    ).filter((key) => !(values.role === "Support" && key === "Admins"));

    let totalSelectedPermissions = 0;

    for (const key of allPermissionCategories) {
      const selectedPermissions = values.permission[key] || [];
      totalSelectedPermissions += selectedPermissions.length;
    }

    // At least one permission must be selected overall
    return totalSelectedPermissions > 0;
  };

  const shouldDisableButtonAlternative = () => {
    if (submitting) {
      return true;
    }

    if (phoneError) {
      return true;
    }

    // Check username availability - disable if checking or username is taken
    if (usernameStatus.isChecking || usernameStatus.isAvailable === false) {
      return true;
    }

    if (!hasRequiredFieldValues()) {
      return true;
    }

    if (isEdit) {
      if (
        (["Admin"].includes(values?.role) || values.adminId) &&
        !arePermissionsValid()
      ) {
        return true;
      }

      if (!dirty) {
        return true;
      }

      return false;
    }

    if (
      (["Admin"].includes(values?.role) || values.adminId) &&
      !arePermissionsValid()
    ) {
      return true;
    }

    return false;
  };

  const safeValidateField = (fieldName) => {
    if (typeof validateField === "function") {
      return validateField(fieldName);
    }
    setFieldTouched(fieldName, true);
  };
  return (
    <>
    {/* <Button
  variant="outline-warning"
  onClick={() => {
    setFieldValue("permission", {}); // Reset only the permission field
  }}
>
  Reset Permissions
</Button> */}
      <BForm onSubmit={handleSubmit} className="px-3">
        <Row className="gy-3">
          <Col md={6} sm={12}>
            <BForm.Label>Email</BForm.Label>
            <BForm.Control
              type="text"
              name="email"
              placeholder="Enter email address"
              value={values.email}
              onChange={handleRealTimeChange}
              onBlur={handleRealTimeBlur}
              // disabled={isEdit}
              isInvalid={shouldShowValidation("email") && !!errors.email}
              isValid={
                shouldShowValidation("email") && !errors.email && values.email
              }
            />
            {shouldShowValidation("email") && errors.email && (
              <BForm.Control.Feedback type="invalid">
                {errors.email}
              </BForm.Control.Feedback>
            )}
            {shouldShowValidation("email") && !errors.email && values.email && (
              <BForm.Control.Feedback type="valid">
                Email looks good!
              </BForm.Control.Feedback>
            )}
          </Col>

          <Col md={6} sm={12}>
            <BForm.Label>
              Password{" "}
              {isEdit && (
                <small className="text-muted">
                  (leave blank to keep current)
                </small>
              )}
            </BForm.Label>
            <InputGroup>
              <BForm.Control
                type={passwordType}
                name="password"
                placeholder={
                  isEdit ? "Enter new password (optional)" : "Enter password"
                }
                autoComplete="new-password"
                value={values.password}
                onChange={handleRealTimeChange}
                onBlur={handleRealTimeBlur}
                isInvalid={
                  shouldShowValidation("password") && !!errors.password
                }
                isValid={
                  shouldShowValidation("password") &&
                  !errors.password &&
                  values.password
                }
              />
              <InputGroup.Text className="b-1">
                <FontAwesomeIcon
                  icon={passwordType === "password" ? faEyeSlash : faEye}
                  style={{ cursor: "pointer" }}
                  onClick={togglePassword}
                />
              </InputGroup.Text>
            </InputGroup>
            {shouldShowValidation("password") && errors.password && (
              <div className="invalid-feedback d-block">{errors.password}</div>
            )}
            {shouldShowValidation("password") &&
              !errors.password &&
              values.password && (
                <div className="valid-feedback d-block">Password is valid!</div>
              )}
          </Col>
        </Row>

        <Row className="gy-3 mt-3">
          <Col md={6} sm={12}>
            <BForm.Label>First Name</BForm.Label>
            <BForm.Control
              type="text"
              name="firstName"
              placeholder="Enter first name"
              value={values.firstName}
              onChange={handleRealTimeChange}
              onBlur={handleRealTimeBlur}
              isInvalid={
                shouldShowValidation("firstName") && !!errors.firstName
              }
              isValid={
                shouldShowValidation("firstName") &&
                !errors.firstName &&
                values.firstName
              }
            />
            {shouldShowValidation("firstName") && errors.firstName && (
              <BForm.Control.Feedback type="invalid">
                {errors.firstName}
              </BForm.Control.Feedback>
            )}
            {shouldShowValidation("firstName") &&
              !errors.firstName &&
              values.firstName && (
                <BForm.Control.Feedback type="valid">
                  Looks good!
                </BForm.Control.Feedback>
              )}
          </Col>

          <Col md={6} sm={12}>
            <BForm.Label>Last Name</BForm.Label>
            <BForm.Control
              type="text"
              name="lastName"
              placeholder="Enter last name"
              value={values.lastName}
              onChange={handleRealTimeChange}
              onBlur={handleRealTimeBlur}
              isInvalid={shouldShowValidation("lastName") && !!errors.lastName}
              isValid={
                shouldShowValidation("lastName") &&
                !errors.lastName &&
                values.lastName
              }
            />
            {shouldShowValidation("lastName") && errors.lastName && (
              <BForm.Control.Feedback type="invalid">
                {errors.lastName}
              </BForm.Control.Feedback>
            )}
            {shouldShowValidation("lastName") &&
              !errors.lastName &&
              values.lastName && (
                <BForm.Control.Feedback type="valid">
                  Looks good!
                </BForm.Control.Feedback>
              )}
          </Col>
        </Row>

        <Row className="gy-3 mt-3">
          <Col md={6} sm={12}>
            <BForm.Label>Username</BForm.Label>
            <BForm.Control
              type="text"
              name="adminUsername"
              placeholder="Enter username"
              value={values.adminUsername}
              onChange={handleUsernameFieldChange}
              onBlur={handleRealTimeBlur}
              autoComplete="off"
              isInvalid={
                (shouldShowValidation("adminUsername") && !!errors.adminUsername) ||
                usernameStatus.isAvailable === false
              }
              isValid={
                shouldShowValidation("adminUsername") &&
                !errors.adminUsername &&
                values.adminUsername &&
                usernameStatus.isAvailable === true
              }
            />
            
            {/* Username checking spinner */}
            {usernameStatus.isChecking && values.adminUsername && values.adminUsername.trim().length >= 3 && (
              <div className="d-flex align-items-center mt-1">
                <Spinner size="sm" className="me-2" />
                <small className="text-muted">{usernameStatus.message}</small>
              </div>
            )}
            
            {/* Error feedback */}
            {((shouldShowValidation("adminUsername") && errors.adminUsername) || 
              (usernameStatus.isAvailable === false && values.adminUsername && values.adminUsername.trim().length >= 3)) && (
              <BForm.Control.Feedback type="invalid">
                {errors.adminUsername || (usernameStatus.isAvailable === false ? usernameStatus.message : '')}
              </BForm.Control.Feedback>
            )}
            
            {/* Success feedback */}
            {shouldShowValidation("adminUsername") &&
              !errors.adminUsername &&
              values.adminUsername &&
              values.adminUsername.trim().length >= 3 &&
              usernameStatus.isAvailable === true && (
                <BForm.Control.Feedback type="valid">
                  {usernameStatus.message}
                </BForm.Control.Feedback>
              )}
          </Col>

          <Col md={6} sm={12}>
            <BForm.Label>Phone Number</BForm.Label>
            <div className="phone-input-container">
              <PhoneInput
                country={!isEdit && values.countryCode ? values.countryCode.toLowerCase() : "us"}
                value={`${(values.phoneCode || "").replace("+", "")}${values.phone || ""}`}

                onChange={(phone, country) => {
                  const dialCode = "+" + country.dialCode;
                  const phoneNumber = phone.substring(country.dialCode.length);

                  // Only allow digits and limit to 10 digits max
                  const cleanPhoneNumber = phoneNumber
                    .replace(/\D/g, "")
                    .slice(0, 10);

                  console.log('phoneCode:::::::', dialCode);
                  console.log('cleanPhoneNumber:::::::', cleanPhoneNumber);
                  console.log('countryCode:::::::', country.countryCode);

                  setFieldValue("phoneCode", dialCode);
                  setFieldValue("phone", cleanPhoneNumber);
                  setFieldValue(
                    "countryCode",
                    country.countryCode.toUpperCase()
                  );

                  // Check if phone number has changed and auto-set verification status
                  if (isEdit && hasPhoneChanged(dialCode, cleanPhoneNumber)) {
                    console.log('Phone number changed, setting isPhoneVerified to false');
                    setFieldValue("isPhoneVerified", false);
                  }

                  // Mark phone as touched for real-time validation
                  setFieldTouched("phone", true);

                  // Reconstruct the full phone number for validation
                  const fullPhoneForValidation =
                    country.dialCode + cleanPhoneNumber;
                  const error = validatePhone(fullPhoneForValidation, country);
                  setPhoneError(error);
                }}
               
                onBlur={() => setFieldTouched("phone", true)}
                enableSearch={true}
                searchPlaceholder="Search countries"
                placeholder="Enter phone number"
                countryCodeEditable={false}
                preferredCountries={["us", "gb", "ca", "au", "de", "fr", "in"]}
                autoFormat={true}
                enableLongNumbers={false}
                disableDropdown={false}
                searchNotFound="No countries found"
                inputProps={{
                  onKeyPress: (e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  },
                  onInput: (e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    const phoneNumberPart = value.substring(
                      values.phoneCode?.replace("+", "").length || 0
                    );

                    if (phoneNumberPart.length > 10) {
                      e.target.value =
                        values.phoneCode?.replace("+", "") +
                        phoneNumberPart.slice(0, 10);
                    }
                  },
                }}
              />

              <div className="d-flex mt-1 align-items-center justify-content-between w-100 gap-3">
                <div className="d-flex align-items-center gap-1 pt-1">
                  <span
                    className="fw-bolder"
                    style={{ fontSize: "13px", color: "#0377fc" }}
                  >
                   {values?.isPhoneVerified ? "Verified" : "Not Verified" } 
                  </span>
                  <Toggle
                    size="small"
                    checked={values.isPhoneVerified}
                    onChange={(e) => {
                      setFieldValue("isPhoneVerified", e.target.checked);
                    }}
                    justify="right"
                    // Disable toggle if phone has changed (force false until manually re-enabled)
                    disabled={isEdit && hasPhoneChanged(values.phoneCode, values.phone)}
                  />
                </div>
                {phoneError && (
                  <div className="invalid-feedback d-block">{phoneError}</div>
                )}

                {!phoneError && values.phone && values.phone.length > 0 && (
                  <div className="valid-feedback d-block">
                    Phone number is valid
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>

        <Row className="mt-3 gy-3">
          <Col md={6} sm={12}>
            <BForm.Label>Group</BForm.Label>
            <CreatableSelect
              isClearable
              name="group"
              onCreateOption={handleCreateGroup}
              options={groupOptions}
              value={selectedGroup}
              classNamePrefix="select"
              onChange={(selectedOption) => {
                groupChangeHandler(selectedOption);
                setFieldTouched("group", true);
                // Validate group field after selection
                setTimeout(() => safeValidateField("group"), 100);
              }}
              onBlur={() => {
                handleBlur({ target: { name: "group" } });
                setFieldTouched("group", true);
              }}
              placeholder="Select or create a group"
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor:
                    shouldShowValidation("group") && errors.group
                      ? "#dc3545"
                      : shouldShowValidation("group") &&
                        !errors.group &&
                        values.group
                        ? "#198754"
                        : base.borderColor,
                  "&:hover": {
                    borderColor:
                      shouldShowValidation("group") && errors.group
                        ? "#dc3545"
                        : shouldShowValidation("group") &&
                          !errors.group &&
                          values.group
                          ? "#198754"
                          : base.borderColor,
                  },
                }),
              }}
            />
            {shouldShowValidation("group") && errors.group && (
              <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                {errors.group}
              </div>
            )}
            {shouldShowValidation("group") && !errors.group && values.group && (
              <div
                className="text-success mt-1"
                style={{ fontSize: "0.875em" }}
              >
                Group selected!
              </div>
            )}
          </Col>

          <Col md={6} sm={12}>
            <BForm.Label>Role</BForm.Label>
            <BForm.Select
              name="role"
              value={values.role || ""}
              disabled={isEdit}
              onChange={(e) => {
                roleChangeHandler(e);
                setFieldTouched("role", true);
                // Validate role field after selection
                setTimeout(() => safeValidateField("role"), 100);
              }}
              onBlur={handleRealTimeBlur}
              isInvalid={shouldShowValidation("role") && !!errors.role}
              isValid={
                shouldShowValidation("role") && !errors.role && values.role
              }
            >
              <option value="" disabled hidden>
                Select Role
              </option>
              {adminRoles?.map((roles, index) => (
                <option key={index} value={roles.name}>
                  {roles.name}
                </option>
              ))}
            </BForm.Select>
            {shouldShowValidation("role") && errors.role && (
              <BForm.Control.Feedback type="invalid">
                {errors.role}
              </BForm.Control.Feedback>
            )}
            {shouldShowValidation("role") && !errors.role && values.role && (
              <BForm.Control.Feedback type="valid">
                Role selected!
              </BForm.Control.Feedback>
            )}
          </Col>
        </Row>

        {["Staff", "Manager"].includes(values.role) && (
          <Row className="mt-3">
            <Col md={6} sm={12}>
              <BForm.Label>{supervisorRole}</BForm.Label>
              <BForm.Select
                name="adminId"
                value={values.adminId || ""}
                disabled={isEdit}
                onChange={(e) => {
                  handleChange(e);
                  setFieldTouched("adminId", true);
                  // Validate adminId field after selection
                  setTimeout(() => safeValidateField("adminId"), 100);
                }}
                onBlur={handleRealTimeBlur}
                isInvalid={shouldShowValidation("adminId") && !!errors.adminId}
                isValid={
                  shouldShowValidation("adminId") &&
                  !errors.adminId &&
                  values.adminId
                }
              >
                {isEdit && (
                  <option value="">{`${values.parentFirstName || ''} ${values.parentLastName || ''}`}</option>
                )}
                <option value="" disabled hidden>
                  Select {supervisorRole}
                </option>
                {adminsList.length === 0 && (
                  <option value="" disabled>
                    No {supervisorRole} Found
                  </option>
                )}
                {adminsList?.map((admin, index) => (
                  <option key={index} value={admin.adminUserId}>
                    {`${admin.firstName} ${admin.lastName}`}
                  </option>
                ))}
              </BForm.Select>
              {shouldShowValidation("adminId") && errors.adminId && (
                <BForm.Control.Feedback type="invalid">
                  {errors.adminId}
                </BForm.Control.Feedback>
              )}
              {shouldShowValidation("adminId") &&
                !errors.adminId &&
                values.adminId && (
                  <BForm.Control.Feedback type="valid">
                    {supervisorRole} selected!
                  </BForm.Control.Feedback>
                )}
            </Col>
          </Row>
        )}

        {(["Admin"].includes(values?.role) || values.adminId) && (
          <Card className="mt-3" key={values?.role}>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <span>Permissions</span>
              {!arePermissionsValid() && (
                <small className="text-danger">
                  Please select at least one permission
                </small>
              )}
            </Card.Header>

            {adminDetails?.userPermission && (
              <Card.Body className="px-2 px-md-4">
                {(() => {
                  
                  let parentPermissionSource = {};

                  if (values?.role === "Admin") {
                    parentPermissionSource = UserPermissions;
                  } else if (isEdit) {
                    parentPermissionSource = adminDetails?.parentData?.parentPermissions || {};
                  } else {
                    parentPermissionSource = managrialPermissions?.userPermission?.permission || {};
                    // parentPermissionSource = adminDetails?.userPermission?.permission || {};
                  }


                  { console.log({ values, isEdit , managrialPermissions}, "pppppppp------------------------------", "adminDetails?.parentData?.parentPermissions", { managrialPermissions }) }

                  return Object.keys(parentPermissionSource).map((key, index) => {
                    const perms = parentPermissionSource[key] || [];


                    if ((values.role === "Staff" && key === "Admins") || perms.length === 0) {
                      return null;
                    }

                    return (
                      <Row key={index} className="permission-row mb-3">
                        <Col md={3} sm={12} className="mb-2 mb-md-0" style={{ wordBreak: 'break-all' }}>
                          <BForm.Label className="fw-bold">{key}</BForm.Label>
                        </Col>

                        <Col md={9} sm={12}>
                          <div className="d-flex flex-wrap gap-2">
                            {perms.map((value, permIndex) => (
                              <label key={permIndex} className="mb-0">
                                <input
                                  className="d-none"
                                  type="checkbox"
                                  name={`permission[${key}]`}
                                  value={value}
                                  checked={
                                    values.permission?.[key]?.includes(value) || false
                                  }
                                  onChange={(e) => {
                                    const handler =
                                    parentPermissionSource?.[key]?.includes("R")
                                        ? permissionHandler
                                        : handleChange;

                                    handler(e, key);
                                    setFieldTouched(`permission.${key}`, true);
                                    setTimeout(() => { }, 50);
                                  }}
                                />
                                <Badge
                                  className="p-2 m-0 m-md-1"
                                  type="button"
                                  bg={
                                    values.permission?.[key]?.includes(value)
                                      ? "success"
                                      : "primary"
                                  }
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {key === "Alert"
                                    ? customLabel(value)
                                    : permissionLabel(value)}
                                </Badge>
                              </label>
                            ))}
                          </div>
                        </Col>
                      </Row>
                    );
                  });
                })()}
              </Card.Body>
            )}
          </Card>
        )}

        <div className="staff-form-button-container">
          <Button
            variant="success"
            type="submit"
            disabled={shouldDisableButtonAlternative() 
              || !isValid 
            }
          >
            {isEdit ? "Update" : "Create"} Staff
            {submitting && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="ms-2"
              />
            )}
          </Button>
          <Button
            onClick={() => {
              navigate(AdminsRoutes.Staff);
            }}
            type="button"
            variant=""
            style={{
              backgroundColor: '#495057', // much darker
              color: '#fff',
            }}
          >
            Cancel
          </Button>
        </div>
      </BForm>
    </>
  );
};

export default StaffForm;